module.exports = __webpack_public_path__ + "img/VG.1f41a0c2.png";